import { env } from '@hb/hbridge';
import { getVipBiz } from '@/utils/vip';
import { getTokenAndKey } from '@/utils';
import { getSignChannels } from '@/api/vip';
import { getSystemCode, getVersion } from '@/utils/systemCode';
import {
  RIGHTS_TYPE,
  COUPON_STATUS,
  COUPON_BUTTON_MAP,
  COUPON_ORIGIN_STATUS_MAP,
} from '../consts';
import { VIP_BIZ } from '../../../const/vip';

export const desc = (val) => {
  if (val.propType === 4) {
    return val.propName;
  }
  if (val.isDiscount) {
    return `${val.amount}元封顶`;
  }
  return val.propThreshold ? `满${val.propThreshold}元减` : '无门槛券';
};

export const getName = (value, multiFlag = false) => {
  if (!env.isEasyBikeApp && value === '去使用') {
    return '去APP使用';
  }
  if (multiFlag && value === '领取') {
    return '选TA';
  }
  return value;
};

export const getFontSize = (value, isFirstWait = false, isMulti = false) => {
  if (value && value.length > 4) {
    if (isMulti) {
      return 'fontSize: 0.09rem';
    }
    return isFirstWait ? 'fontSize: 0.1rem' : 'fontSize: 0.09rem';
  }
  return '';
};

const versionAli = (propType, propEffectiveDays, descTitle, version) => {
  // 未开卡 门槛 新老版会员
  if (!env.isEasyBikeApp && version !== 'ride_universal') {
    return '限APP使用';
  }
  return propType === 4 ? `${propEffectiveDays}天可用` : descTitle;
};
// const getNumber = (vipExtendProperty, propDiscount, amount, propType) => {
//   if (vipExtendProperty) {
//     return (vipExtendProperty.propType === RIGHTS_TYPE.discount) ? vipExtendProperty.propDiscount
//       : vipExtendProperty.propAmount;
//   }
//   return (propType === RIGHTS_TYPE.discount) ? propDiscount : amount;
// };
const getMoney = (vipExtendProperty, propType, propDiscount, propAmount, propTimes) => {
  if (vipExtendProperty) {
    // eslint-disable-next-line no-nested-ternary
    return (vipExtendProperty.propType !== 4 && vipExtendProperty.propType !== 7)
      ? ((vipExtendProperty.propType === RIGHTS_TYPE.discount) ? vipExtendProperty.propDiscount
        : vipExtendProperty.propAmount) : vipExtendProperty.propTimes;
  }
  // eslint-disable-next-line no-nested-ternary
  return (propType !== 4 && propType !== 7) ? ((propType === RIGHTS_TYPE.discount)
    ? propDiscount : propAmount) : propTimes;
};

export const couponsData = (list, version) => list.map(({
  propName,
  propAmount,
  propAmount: amount,
  propName: title,
  propThreshold,
  goodsPropGuid,
  propNum,
  propTag,
  propType,
  propDiscount,
  propBusinessLine,
  propIcon,
  goodsPropDesc,
  ladderMarsCode,
  ladderNum,
  propCode,
  propDesc,
  propEffectiveDays,
  propUrl,
  propTimes,
  vipExtendProperty,
  extendPropType, // 膨胀类型 1普通膨胀 2免单
}) => {
  const descs = () => {
    const isDiscount = propType === RIGHTS_TYPE.discount;

    if (isDiscount) {
      return `${amount}元封顶`;
    } if (
      propType === RIGHTS_TYPE.ride
    ) {
      return title;
    }
    //  金融业务线展示指定的优惠信息
    if (getVipBiz(propBusinessLine) === VIP_BIZ.FINANCIAL) {
      return '最高可优惠';
    }
    return propThreshold ? `满${propThreshold}元减` : '无门槛';
  };
  // eslint-disable-next-line consistent-return
  const getWord = () => {
    if (env.isAlipayBrowser || ((env.isAliMP || env.isAliMPMonitor) && version !== 'ride_universal')) {
      return '去APP使用';
    }

    return (propType === 4 || propType === 7) ? `${propEffectiveDays}天可用` : descs();
  };

  const isDiscount = propType === RIGHTS_TYPE.discount;
  // eslint-disable-next-line no-nested-ternary
  const descTitle = isDiscount ? `${propAmount}元封顶` : (propThreshold ? `满${propThreshold}元减` : '无门槛');
  const coupon = {
    title: propName,
    subtitle: descTitle,
    // eslint-disable-next-line no-nested-ternary
    amount: (propType !== 4 && propType !== 7)
      ? (isDiscount ? propDiscount : propAmount) : propTimes,
    // eslint-disable-next-line no-nested-ternary
    unit: (propType !== 4 && propType !== 7) ? (isDiscount ? '折' : '元') : '次',
    goodsPropGuid,
    corner: propTag ? '新人券' : '',
    propNum,
    propBusinessLine,
    bizType: getVipBiz(propBusinessLine),
    propIcon,
    goodsPropDesc,
    ladderMarsCode,
    ladderNum,
    propCode,
    propDesc,
    propEffectiveDays,
    propName,
    propUrl,
    propType,
    propTimes,
    // eslint-disable-next-line no-nested-ternary
    cardNum: (propType !== 4 && propType !== 7)
      ? (isDiscount ? propDiscount : propAmount) : propTimes,
    // eslint-disable-next-line no-nested-ternary
    cardMoney: getMoney(vipExtendProperty, propType, propDiscount, propAmount, propTimes),
    // eslint-disable-next-line no-nested-ternary
    cardSign: (propType !== 4 && propType !== 7) ? (isDiscount ? '折' : '元') : '次',
    couponWord: versionAli(propType, propEffectiveDays, descTitle, version),
    vipExtendProperty,
    subWord: getWord(),
    extendPropType,
  };
  return coupon;
}).reduce((acc, vals) => acc.concat(vals), []);

export const filterNoOpenData = (list, version) => list.map((g) => {
  const {
    groupAmount: amount, groupCode, groupIndex, propList,
  } = g;
  return {
    amount,
    groupCode,
    groupIndex,
    coupons: couponsData(propList || [], version),
  };
});

export function CouponMapper(coupon, version = '') {
  const {
    changeRecord,
    appJumpUrl,
    propAmount: amount,
    status,
    propThreshold,
    propName: title,
    propType,
    propDiscount,
    statusDesc,
    goodsPropDesc,
    propUrl,
    propNum,
    propIcon,
    ladderNum,
    propEffectiveDays,
    userVipPropGuid,
    ladderMarsCode,
    groupCode,
    propBusinessLine,
    jumpButtonDesc,
    goToFinishNum,
    commonJumpUrl,
    sceneKey,
    businessLineName,
    propTimes,
    vipExtendProperty,
    rideCardInfo,
    goodsPropGuid,
    afterVipExtendProperty,
    afterVipRecycleProperty,
    afterVipReplacementProperty,
    propCode,
    propName,
    guid,
    extendPropType,
    coverTitleUrl,
    endTime,
    expansionType,
  } = coupon;

  const isDiscount = propType === RIGHTS_TYPE.discount;
  const descs = (newParam) => {
    if (isDiscount) {
      return `${amount}元封顶`;
    } if (
      propType === RIGHTS_TYPE.ride
    ) {
      return title;
    }
    //  金融业务线展示指定的优惠信息
    if (getVipBiz(propBusinessLine) === VIP_BIZ.FINANCIAL) {
      return '最高可优惠';
    }
    if (newParam) {
      return propThreshold ? `满${propThreshold}元减` : '无门槛';
    }
    return propThreshold ? `满${propThreshold}元减` : '无门槛券';
  };

  // eslint-disable-next-line consistent-return
  const getWord = (newParam) => {
    // 此方法已开卡 门槛信息 新版/老版
    if (!env.isEasyBikeApp && version !== 'ride_universal') {
      return '限APP使用';
    }
    return (propType === 4 || propType === 7) ? `${propEffectiveDays}天可用` : descs(newParam);
  };

  const getNumber = () => {
    const numberInfo = vipExtendProperty || changeRecord || null;
    if (numberInfo) {
      // eslint-disable-next-line no-nested-ternary
      if (numberInfo.propType !== 4 && numberInfo.propType !== 7) {
        return (numberInfo.propType === RIGHTS_TYPE.discount)
          ? numberInfo.propDiscount : numberInfo.propAmount;
      }
      if (numberInfo.rideCardInfo) {
        return numberInfo.rideCardInfo.useProperty.remainCardTimes;
      }
      return numberInfo.propTimes;
    }
    if (propType === 4 || propType === 7) {
      if (rideCardInfo) {
        return rideCardInfo.useProperty.remainCardTimes;
      }
      return propTimes;
    }
    // eslint-disable-next-line no-nested-ternary
    return (propType !== 4 && propType !== 7) ? (isDiscount ? propDiscount : amount) : propTimes;
  };

  const getStaus = () => {
    if (propType !== 4 && propType !== 7) {
      return COUPON_ORIGIN_STATUS_MAP[status] || COUPON_STATUS.expired;
    }
    if (status === COUPON_STATUS.use) {
      if (rideCardInfo) {
        if (rideCardInfo.totalCardTimes && rideCardInfo.totalCardTimes > 0 && getNumber()) {
          return COUPON_ORIGIN_STATUS_MAP[status] || COUPON_STATUS.expired;
        }
        if (!rideCardInfo.totalCardTimes) {
          return COUPON_ORIGIN_STATUS_MAP[status] || COUPON_STATUS.expired;
        }
        return COUPON_STATUS.achieve;
      }
      return COUPON_STATUS.achieve;
      // 单车卡特殊处理 不知道状态
    }
    return COUPON_ORIGIN_STATUS_MAP[status] || COUPON_STATUS.expired;
  };

  // eslint-disable-next-line consistent-return
  const getBtnName = () => {
    if (propType !== 4 && propType !== 7) {
      return COUPON_BUTTON_MAP[status] || '已作废';
    }
    if (status === COUPON_STATUS.use) {
      if (rideCardInfo && getNumber() > 0) {
        return COUPON_BUTTON_MAP[status] || '已作废';
      }
      return '已使用';
    }
    return COUPON_BUTTON_MAP[status] || '已作废';
  };


  const item = {
    amount: getNumber(),
    title,
    subtitle: descs(),
    id: Math.random(),
    btnName: getBtnName(),
    status: getStaus(),
    // eslint-disable-next-line no-nested-ternary
    unit: (propType !== 4 && propType !== 7) ? (isDiscount ? '折' : '元') : '次',
    detail: coupon,
    statusDesc,
    goodsPropDesc,
    propUrl,
    propNum,
    propIcon,
    ladderNum,
    propEffectiveDays,
    userVipPropGuid,
    ladderMarsCode,
    groupCode,
    propBusinessLine,
    jumpButtonDesc,
    goToFinishNum,
    commonJumpUrl,
    sceneKey,
    propType,
    businessLineName,
    appJumpUrl,
    propTimes,
    subWord: getWord(),
    subNewWord: getWord('new'),
    goodsPropGuid,
    afterVipExtendProperty,
    afterVipRecycleProperty,
    afterVipReplacementProperty,
    propCode,
    propName,
    changeRecord,
    guid,
    extendPropType,
    expansionType,
    // eslint-disable-next-line no-nested-ternary
    cardSign: (propType !== 4 && propType !== 7) ? (isDiscount ? '折' : '元') : '次',
    coverTitleUrl,
    endTime,
  };

  return item;
}

export const showTime = (timeout) => {
  let D = '';
  let H = '';
  let M = '';
  let S = '';
  if (timeout && timeout > 0) {
    const t = timeout;
    // eslint-disable-next-line no-console
    // 如果后台给的是毫秒 上面不用除以1000  下面的计算时间也都要除以1000 这里我去掉1000了
    const d = Math.floor(t / 1000 / 60 / 60 / 24); // 天 var d=Math.floor(t/1000/60/60/24)
    // eslint-disable-next-line no-mixed-operators
    const h = Math.floor((t / 1000 / 60 / 60) % 24);
    // 时 var h=Math.floor(t/1000/60/60%24)
    // eslint-disable-next-line no-mixed-operators
    const m = Math.floor((t / 1000 / 60) % 60); // 分 var m=Math.floor(t/1000/60%60)
    // eslint-disable-next-line no-mixed-operators
    const s = Math.floor((t / 1000) % 60); // 秒 var s=Math.floor(t/1000%60)
    // if (parseInt(d, 10) < 10) {
    //   D = `0${d}`;
    // } else {
    //   D = `${d}`;
    // }
    D = `${d}`;
    if (parseInt(h, 10) < 10) {
      H = `0${h}`;
    } else {
      H = `${h}`;
    }
    if (parseInt(m, 10) < 10) {
      M = `0${m}`;
    } else {
      M = `${m}`;
    }
    if (parseInt(s, 10) < 10) {
      S = `0${s}`;
    } else {
      S = `${s}`;
    }
  }
  return {
    D, H, M, S,
  };
};
export function groupByLadderNum(propList, version = '') {
  if (!propList || !propList.length) return [{ coupons: [] }];
  if (version === 'ladder_blend' || version === 'ladder_blend_two') {
    let multiFlag = false;

    const result = new Map();
    propList.forEach((item) => {
      const { ladderNum } = item;
      if (!result.has(ladderNum)) {
        result.set(
          ladderNum,
          {
            ladderNum,
            coupons: [],
          },
        );
      } else {
        multiFlag = true;
      }
      result.get(ladderNum).coupons.push(item);
    });
    if (multiFlag) { return Array.from(result.values()); }
  }
  return [{ coupons: propList.slice(0, 4) }];
}
export function groupByLadderArray(arr) {
  if (!arr || !arr.length) return [];
  const map = new Map();

  // 遍历数组，按照 ladderNum 进行聚类和计数
  arr.forEach((item) => {
    const { ladderNum } = item;
    if (!map.has(ladderNum)) {
      map.set(ladderNum, []);
    }
    map.get(ladderNum).push(item);
  });

  const result = [];
  map.forEach((items) => {
    const firstItem = items[0];
    firstItem.allCoupons = items;

    // 是否一个阶梯中 有多张券
    firstItem.multiFlag = items.length > 1;

    // 将处理后的对象加入到结果数组中
    result.push(firstItem);
  });

  return result;
}


export async function getSignChannelsData({ propVersion = '' }) {
  try {
    const { token } = await getTokenAndKey();
    const res = await getSignChannels({
      token,
      version: await getVersion(),
      systemCode: getSystemCode(),
      propVersions: [propVersion],
    });

    if (res && res.data && res.data.length > 0) {
      const temp = res.data.find((x) => x.propVersion === propVersion);
      return temp || null;
    }
    return null;
  } catch (e) {
    return null;
  }
}

/**
 * 判断是否应该展示（自然日频控）
 * @param {string} storageKey - localStorage 存储的 key
 * @returns {boolean} 是否应该展示
 */
export function shouldShowByDailyFrequency(storageKey) {
  try {
    const lastShownDate = localStorage.getItem(storageKey);
    const today = new Date().toDateString();
    return lastShownDate !== today;
  } catch {
    return true; // localStorage 不可用时降级为展示
  }
}

/**
 * 标记已展示（自然日频控）
 * @param {string} storageKey - localStorage 存储的 key
 */
export function markDailyFrequencyShown(storageKey) {
  try {
    const today = new Date().toDateString();
    localStorage.setItem(storageKey, today);
  } catch {
    // localStorage 不可用时静默失败
  }
}
